import { defineBlock, smartProps, useSmartProp, useInspectorControl } from '@smartfire/js-block-engine';
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, Stack } from '@mui/material';
// components
import Logo from '../components/Logo';
import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';
import MinimalWrapper from '../minimal-wrapper/block';
import { EditableText } from '@smartfire/components';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    position: 'relative',
    backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function MainFooter({ divider, menu }) {
    const menuList = menu
        ? Object.values(menu)
        : [
              { title: 'Menu Admin 1', child: [{ title: 'Example url' }] },
              { title: 'Menu Admin 2', child: [{ title: 'Example url' }] },
              { title: 'Menu Admin 3', child: [{ title: 'Example url' }] },
          ];
    return (
        <RootStyle>
            {divider ? <Divider /> : null}
            <Container sx={{ pt: 10 }}>
                <Grid
                    container
                    justifyContent={{ xs: 'center', md: 'space-between' }}
                    sx={{ textAlign: { xs: 'center', md: 'left' } }}
                >
                    <Grid item xs={12} sx={{ mb: 3 }}>
                        <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
                    </Grid>
                    <Grid item xs={8} md={3}>
                        <Typography variant="body2" sx={{ pr: { md: 5 } }} component="div">
                            <EditableText
                                smartProp="description"
                                placeholder="Enter a title"
                                allowedFormats={['core/link', 'advanced/color', 'core/bold', 'core/italic']}
                            />
                        </Typography>

                        {/*
                        <Stack
                            direction="row"
                            justifyContent={{ xs: 'center', md: 'flex-start' }}
                            sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
                        >
                            <SocialsButton sx={{ mx: 0.5 }} />
                        </Stack>*/}
                    </Grid>

                    <Grid item xs={12} md={7}>
                        <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
                            {menuList
                                ? menuList.map((list) => (
                                      <Stack key={list.title} spacing={2}>
                                          {list.url !== '#' ? (
                                              <Link href={list.url}>
                                                  <Typography component="p" variant="overline">
                                                      <span dangerouslySetInnerHTML={{ __html: list.title }} />
                                                  </Typography>
                                              </Link>
                                          ) : (
                                              <Typography component="p" variant="overline">
                                                  <span dangerouslySetInnerHTML={{ __html: list.title }} />
                                              </Typography>
                                          )}
                                          {list.child
                                              ? list.child.map((link) => (
                                                    <Link
                                                        href={link.url}
                                                        key={link.title}
                                                        color="inherit"
                                                        variant="body2"
                                                        sx={{ display: 'block' }}
                                                    >
                                                        <span dangerouslySetInnerHTML={{ __html: link.title }} />
                                                    </Link>
                                                ))
                                              : null}
                                      </Stack>
                                  ))
                                : null}
                        </Stack>
                    </Grid>
                </Grid>

                <Typography
                    component="p"
                    variant="body2"
                    sx={{
                        mt: 10,
                        pb: 5,
                        fontSize: 13,
                        textAlign: { xs: 'center', md: 'left' },
                    }}
                >
                    © 2022. All rights reserved
                </Typography>
            </Container>
        </RootStyle>
    );
}

function Inspector() {
    const [divider, setDivider] = useSmartProp('divider');

    return (
        <>
            <PanelBody title="Settings" initialOpen={true}>
                <PanelRow>
                    <ToggleControl label="Divider" checked={divider} onChange={setDivider} />
                </PanelRow>
            </PanelBody>
        </>
    );
}

function Block(props) {
    useInspectorControl(Inspector);
    return (
        <MinimalWrapper>
            <MainFooter {...props} />
        </MinimalWrapper>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        divider: smartProps.bool.withDefault(false),
        description: smartProps.string.withDefault(
            'The starting point for your next project with Minimal UI Kit, built on the newest version of Material-UI ©, ready to be customized to your style.',
        ),
    },
    setup: {},
});
